import { all, call, put, takeLatest } from "redux-saga/effects";

import {
    ARTICLE_PHOTO_FETCH_TRIGGER,
    ArticlePhotoFetchNormalizedResponse,
    ArticlePhotoFetchTriggerAction,
    articlePhotoFetchApi,
} from "@/mk2/apps/wiki/containers/ArticlePhoto/ArticlePhoto.actions";
import {
    XHRAction,
    XHRError,
    XHRGetError,
    handleXHRGetErrorSaga,
    normalizeError,
} from "@/mk2/helpers/api";
import { getLogger } from "@/mk2/logger";
import { PhotoEntity, WikiArticleEntity, WikiArticleSchema } from "@/mk2/schemas";
import { getDenormalizedEntity } from "@/mk2/selectors";
import { wiki_api_v2_get_article_url } from "@/mk/urls/functions";

const logger = getLogger("wiki/Article.sagas");

interface ApiResponseFetchArticle {
    body: ArticlePhotoFetchNormalizedResponse;
}

function* fetch({
    articleSlug,
    categorySlug,
    photoId,
    xhr,
}: ArticlePhotoFetchTriggerAction & XHRAction) {
    yield put(articlePhotoFetchApi.request(articleSlug, categorySlug, photoId));

    try {
        const response: ApiResponseFetchArticle = yield call(() =>
            xhr.get(wiki_api_v2_get_article_url(), { articleSlug, categorySlug }),
        );

        const articlePhotos: PhotoEntity[] = getDenormalizedEntity<WikiArticleEntity>(
            response.body,
            WikiArticleSchema,
            response.body.result.article,
        ).photos;
        const articlePhoto = articlePhotos.find((p) => p.id === photoId);
        if (!articlePhoto) {
            const err = new Error(
                "Photo not found",
            ) as XHRError<ArticlePhotoFetchNormalizedResponse>;
            err.status = 404;
            err.response = response;
            throw err;
        }

        yield put(articlePhotoFetchApi.success(articleSlug, categorySlug, photoId, response.body));
    } catch (error) {
        yield handleXHRGetErrorSaga(error as XHRGetError, logger);
        yield put(
            articlePhotoFetchApi.failure(articleSlug, categorySlug, photoId, normalizeError(error)),
        );
    }
}

export default function* root() {
    yield all([takeLatest(ARTICLE_PHOTO_FETCH_TRIGGER, fetch)]);
}
